import Supplier from './Supplier';
export default Supplier;
